module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousFFView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Custom Clearance Import Tracking")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-form', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "success",
      "id": "addButtonLoaderpro"
    },
    on: {
      "click": _vm.proceedToInv
    }
  }, [_vm._v("Generate Invoice")])], 1)], 1)], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "id": "checkbox-1",
      "name": "checkbox-1",
      "value": "0",
      "unchecked-value": "1"
    },
    on: {
      "change": _vm.addSameDateRadio
    },
    model: {
      value: (_vm.allSame),
      callback: function($$v) {
        _vm.allSame = $$v
      },
      expression: "allSame"
    }
  }, [_vm._v("Dates are Same")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "id": "checkbox-2",
      "name": "checkbox-2",
      "value": "0",
      "unchecked-value": "1"
    },
    on: {
      "change": _vm.addSameDateReturn
    },
    model: {
      value: (_vm.allSameReturn),
      callback: function($$v) {
        _vm.allSameReturn = $$v
      },
      expression: "allSameReturn"
    }
  }, [_vm._v("Dates are Same")])], 1)], 1), _vm._v(" "), _vm._l((_vm.trackModal.allContainer), function(item, index) {
    return _c('md-layout', {
      key: index,
      staticClass: "labelMargtop",
      attrs: {
        "gutter": ""
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "20"
      }
    }, [_c('label', [_vm._v("Container No.")]), _vm._v(" "), _c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "value": item.ContainerNo,
        "disabled": ""
      }
    })], 1), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "5"
      }
    }), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "20"
      }
    }, [(_vm.stuffingType == 'warehouseStuffing') ? _c('label', [_vm._v("De-Stuffing Date")]) : _c('label', [_vm._v("ICD Out Date")]), _vm._v(" "), _c('date-picker', {
      attrs: {
        "format": _vm.selectDateFormat,
        "lang": "en",
        "id": "HAWBDate",
        "name": "HAWBDate"
      },
      model: {
        value: (_vm.icdOutDate[index]),
        callback: function($$v) {
          _vm.$set(_vm.icdOutDate, index, $$v)
        },
        expression: "icdOutDate[index]"
      }
    })], 1), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "5"
      }
    }), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "20"
      }
    }, [_c('label', [_vm._v("Empty Return Date")]), _vm._v(" "), _c('date-picker', {
      attrs: {
        "format": _vm.selectDateFormat,
        "lang": "en",
        "id": "HAWBDate",
        "name": "HAWBDate"
      },
      model: {
        value: (_vm.emptyReturnDate[index]),
        callback: function($$v) {
          _vm.$set(_vm.emptyReturnDate, index, $$v)
        },
        expression: "emptyReturnDate[index]"
      }
    })], 1), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "5"
      }
    }), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "25"
      }
    }, [_c('label', {
      attrs: {
        "for": "stuffingType"
      }
    }, [_vm._v("Remarks")]), _vm._v(" "), _c('b-textarea', {
      attrs: {
        "name": "securityAmount",
        "id": "securityAmount"
      },
      model: {
        value: (_vm.Remark[index]),
        callback: function($$v) {
          _vm.$set(_vm.Remark, index, $$v)
        },
        expression: "Remark[index]"
      }
    })], 1)], 1)
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderpro"
    },
    on: {
      "click": _vm.addTracking
    }
  }, [_vm._v("Save & Submit")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderpro"
    }
  })], 1)], 1)], 2)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "alertAddSeaImp",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseHandover
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23c46a08","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/CCImport/ccImportTracking.vue
// module id = 2465
// module chunks = 0